type BattleType = 'duel' | 'contract-battle' | 'contract-incoming' | 'beast-battle' | 'tournament' | 'team-battle' | 'guild-league';

type PreferenceRecord = Record<string, unknown>;

const buildKey = (mercenaryId: number, battleType: BattleType) => `prefs_${mercenaryId}_${battleType}`;

export const loadBattlePrefs = <T extends PreferenceRecord>(
  mercenaryId: number | undefined,
  battleType: BattleType,
  defaults: T
): T => {
  if (!mercenaryId) return defaults;
  const key = buildKey(mercenaryId, battleType);
  const cookieEntry = document.cookie.split('; ').find((row) => row.startsWith(`${key}=`));
  if (!cookieEntry) return defaults;
  try {
    const raw = decodeURIComponent(cookieEntry.split('=').slice(1).join('='));
    const parsed = JSON.parse(raw) as Partial<T>;
    return { ...defaults, ...parsed };
  } catch {
    return defaults;
  }
};

export const saveBattlePrefs = <T extends PreferenceRecord>(
  mercenaryId: number | undefined,
  battleType: BattleType,
  prefs: T
) => {
  if (!mercenaryId) return;
  const key = buildKey(mercenaryId, battleType);
  const value = encodeURIComponent(JSON.stringify(prefs));
  const expires = new Date(Date.now() + 365 * 24 * 60 * 60 * 1000).toUTCString();
  const secureAttr = window.location.protocol === 'https:' ? '; Secure' : '';
  document.cookie = `${key}=${value}; expires=${expires}; path=/; SameSite=Lax${secureAttr}`;
};
